export default __webpack_public_path__ + "static/media/Megosu-Original.320a2d90.jpg";